export default __webpack_public_path__ + "static/media/blockchain.3759e692.png";